<p-checkbox class="prime-checkbox" [inputId]="checkboxId()" [ngClass]="classes()" [binary]="true"
  [formControl]="ngControl.control" (onChange)="handleChange()" />
